/**
 * Popup do clique numa área de fumaça: o tamanho dela. Horário e fonte já
 * estão no painel e nos créditos.
 */
import { formatInt } from '../lib/format';
import type { AreaFumaca } from './layer';

export function SmokePopup(props: { area: AreaFumaca }) {
  const { km2 } = props.area;
  return (
    <div className="space-y-0.5">
      <div className="font-semibold text-white">Fumaça</div>
      <div className="text-xs text-ink-300 tabular-nums">
        {km2 < 10 ? 'menos de 10 km²' : `cerca de ${formatInt(Math.round(km2 / 10) * 10)} km²`}
      </div>
    </div>
  );
}
